
// mixins
import New3MapTypeBtnMixin from "@/mixins/new-3-map-type-btn";
import { PropType } from "vue";
import TypesMixin from "vue-typed-mixins";
import SplitViewMixin from "@/mixins/split-view";
import MapFilterMixin from "@/mixins/map-filter-buttons";
import { mapState, mapMutations, mapGetters } from "vuex";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import portal from "@vacancorp/portal";
import { MobileDataType as DataType } from "@/components/maps-view/@types/split-view";
// tools
import { showVacancyErrorBannerTitle, vacancyErrorBannerBtnClicked } from "@/mixins/common-functions";
import EventBus from "@/event-bus";
import { Hooper, Slide, Pagination as HooperPagination } from "hooper";
import { sendCardImpression } from "@/mixins/analytics";
import PlaceCategoryMixin2 from "@/mixins/place-category2";
//components
import VacancyErrorBanner from "@/components/common/vacancy-error-banner.vue";
import ProgressBar from "@/components/progress-bar.vue";
import NoShopBanner from "@/components/common/no-shop-banner.vue";
import CardView from "@/components/maps-view/card-view.vue";
import NavigationBottom from "@/components/navigation-bottom-mobile.vue";
import MapHeader2 from "@/components/maps-view/map-header-mobile.vue";
import TopAreaView from "@/views/top-area-view.vue";
import FilterPage from "@/views/filter-page.vue";
import LayoutIosDummy from "@/layouts/layout-ios-dummy.vue";
import MenuView from "@/views/menu-view.vue";
import Spinner from "@/components/common/spinner.vue";

const CARD_HEIGHT_WITH_HEAD = 312 - 8;
const CARD_HEIGHT = 281.8;
const CARD_MARGIN = 8;

type HooperRef = Vue & {
  slideTo: (index: number) => void;
  isDragging: boolean;
  onDragStart: (e: any) => void;
};

export default TypesMixin(SplitViewMixin, MapFilterMixin, PlaceCategoryMixin2, New3MapTypeBtnMixin).extend({
  name: "split-view",
  mixins: [SplitViewMixin, MapFilterMixin, PlaceCategoryMixin2, New3MapTypeBtnMixin],
  components: {
    VacancyErrorBanner,
    ProgressBar,
    Spinner,
    NoShopBanner,
    MenuView,
    LayoutIosDummy,
    CardView,
    NavigationBottom,
    MapHeader2,
    TopAreaView,
    FilterPage,
    Hooper,
    Slide,
    HooperPagination,
  },
  props: {
    isSearchAgain: Boolean,
    placeList: Array as PropType<portal.PublicPlaceWithVacancyId[]>,
  },
  data(): DataType {
    return {
      hideMapHeader: false,
      iconTextOn: true,
      moveCardUpOnTouch: false,
      isHooperDraggable: true,
      hooperSettings: {
        pagination: true,
        infiniteScroll: false,
        wheelControl: false,
        keysControl: false,
        autoPlay: false,
        centerMode: true,
      },
      placeListOnCards: [],
      amountOfPlaceListOnCards: 20,
      pagerOfPlaceListOnCards: 1,
      gMap: this.$store.state.data.gMaps,
      // swipe card view
      cardViewDirection: "up",
      touchedY: 0,
      touchedX: 0,
      scrollLastY: 0,
      currentCardIndex: 0,
      isGMapInAction_duplicate: false,
      showPlaceCategoryList: false,
      hideAreaBar: false,
      loadingPlacesToCards: false,
    };
  },
  watch: {
    moveCardUpOnTouch() {
      if (this.isPlaceListNoData) {
        return;
      }

      this.setSectionOffsetTop(400);
    },
    placeList(newVal: portal.PublicPlaceWithVacancyId[]) {
      // delay for slide-down transition
      setTimeout(() => {
        this.placeListOnCards = newVal.slice(0, this.numberOfPlaceListOnCards);
      }, 400);
    },
    isGMapInAction(newValue: boolean) {
      this.isGMapInAction_duplicate = newValue;
      this.isHooperDraggable = !newValue;
      this.iconTextOn = false;
    },
    isMap(newValue: boolean) {
      if (newValue) {
        this.hideMapHeader = false;
        // map mode
        setTimeout(() => {
          this.moveCardToIndex(this.currentCardIndex);
          this.removeListSroll();
        }, 800);
      }
    },
    showLoadingCard(newValue: boolean) {
      // listen again on after data loaded
      // because DOM was deleted on loading by v-if
      if (!newValue && !this.isMap) {
        setTimeout(() => {
          this.listenListSroll();
        }, 100);
      }
    },
    currentCardIndex(newIndex: number) {
      if (newIndex >= this.numberOfPlaceListOnCards) {
        // push data
        if (!this.loadingPlacesToCards) {
          this.addPagerOfPlaceListOnCards();
          setTimeout(() => {
            this.moveCardMarkerToIndexThenEnlarge(newIndex);
          }, 1000);
          return;
        }
      } else {
        setTimeout(() => {
          this.moveCardMarkerToIndexThenEnlarge(newIndex);
        }, 100);
      }
    },
    numberOfPlaceListOnCards(newVal: number) {
      if (newVal === 0) return;
      this.loadingPlacesToCards = true;
      this.placeListOnCards = this.$store.state.data.sortedPlaceList.slice(0, newVal);
      this.loadingPlacesToCards = false;
    },
  },
  computed: {
    ...mapState("ui", [
      "showLoadingCard",
      "vacancyErrorBannerShown",
      "stringCardHeaderShown",
      "bottomSectionOffsetTop",
    ]),
    ...mapState("data", ["selectedPlaceIdHash"]),
    // getters
    ...mapGetters("ui", ["isMap"]),
    ...mapGetters("data", ["isPlaceListNoData"]),
    cardHeaderShown(): boolean {
      console.log(this.stringCardHeaderShown, this.selectedPlaceIdHash);

      if (this.stringCardHeaderShown && this.selectedPlaceIdHash) {
        this.setSectionOffsetTop();
      }
      return this.stringCardHeaderShown === this.selectedPlaceIdHash;
    },
    showLoadMoreCard(): boolean {
      return !this.showLoadingCard && this.numberOfPlaceListOnCards < this.placeList.length;
    },
    showVacancyErrorBannerTitle(): string {
      return showVacancyErrorBannerTitle();
    },
    showAlertBanner(): boolean {
      return this.alertBar.status;
    },
    takeOffRealCards(): boolean {
      return this.isPlaceListNoData || this.showLoadingCard || this.numberOfPlaceListOnCards === 0;
    },
    numberOfPlaceListOnCards: {
      get(): number {
        const result = this.pagerOfPlaceListOnCards * this.amountOfPlaceListOnCards;
        return result < this.placeList.length ? result : this.placeList.length;
      },
    },
    getItemsToShowOnHooper(): number {
      if (window.innerWidth < 375) {
        return 0.9;
      } else if (window.innerWidth >= 375 && window.innerWidth < 385) {
        return 1.12;
      } else {
        return (window.innerWidth / 375) * 1.12;
      }
    },
    hooperRef(): HooperRef {
      return this.$refs.hooper as HooperRef;
    },
    moveCardDown(): boolean {
      if (
        this.placeListOnCards.length === 0 ||
        ((this.cardViewDirection === "down" || this.isGMapInAction_duplicate) && !this.isPlaceListNoData)
      ) {
        this.moveCardUpOnTouch = false;
        return true;
      } else {
        this.moveCardUpOnTouch = true;
        return false;
      }
    },
    showViewsList(): boolean {
      if (!this.isMap && !this.showTopAreaList && !this.showPlaceCategoryList) {
        // list mode
        setTimeout(() => {
          this.listenListSroll();
          this.scrollCardsUpOnList(this.currentCardIndex);
        }, 100);
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.$once("hook:mounted", () => {
      this.initFilterButtons();
      this.listenSwipeGesture();
      if (!this.isMap) this.checkSelectedPlaceForListView();
    });
    this.$once("hook:beforeDestroy", () => {
      this.removeSwipeGesture();
      this.removeListSroll();
    });
  },
  methods: {
    ...mapMutations("data", ["setSelectedFilterRadioButtons"]),
    ...mapMutations("ui", ["setBottomSectionOffsetTop"]),
    vacancyErrorBannerBtnClicked() {
      vacancyErrorBannerBtnClicked();
    },
    assignCurrentLocationIcon() {
      this.$emit("assign-current-location-icon");
    },
    filterBtnClicked(whichBtn: string) {
      if (whichBtn === "area") {
        this.setShowTopAreaList(true);
        return;
      }
      if (whichBtn === "genre") {
        this.showPlaceCategoryList = true;
        this.hideAreaBar = true;
        return;
      }
      if (whichBtn === "tune") {
        this.showPlaceCategoryList = true;
        this.hideAreaBar = false;
        return;
      }
      // favorite prompt is set in  map-header2
      if (this.hasSelectedFilter(whichBtn)) {
        const index: number = this.selectedFilterRadioButtons.findIndex((category: string) => category === whichBtn);
        if (index >= 0) {
          const list = [...this.selectedFilterRadioButtons];
          list.splice(index, 1);
          this.setSelectedFilterRadioButtons(list);
        }
      } else {
        const list = [...this.selectedFilterRadioButtons];
        list.push(whichBtn);
        this.setSelectedFilterRadioButtons(list);
      }
      // send request
      setTimeout(() => {
        let query: { [Key: string]: number } = {};
        this.selectedFilterRadioButtons.forEach((filterBtnName: string) => {
          query[filterBtnName] = 1;
        });
        this.$emit("filter-btn-clicked");
      }, 100);
    },
    searchBtnClicked() {
      this.$emit("search-again-clicked");
    },
    pollSearchClicked() {
      console.log(`pollSearchBtnClicked on split view`);
      this.$emit("poll-search-clicked");
    },
    cardViewClicked(placeIdHash: string) {
      const index: number = this.placeList.findIndex(
        (place: portal.PublicPlaceWithVacancyId) => place.placeIdHash === placeIdHash,
      );
      this.currentCardIndex = index === -1 ? 0 : index;
    },
    /** @remarks card scroll */
    handleHooperScroll(payload: any) {
      this.currentCardIndex = payload.currentSlide; // index is from 0
    },
    checkSelectedPlaceForListView() {
      const index: number = this.placeList.findIndex(
        (place: portal.PublicPlaceWithVacancyId) => place.placeIdHash === this.selectedPlaceIdHash,
      );
      this.currentCardIndex = index === -1 ? 0 : index;
      this.scrollCardsUpOnList(this.currentCardIndex);
    },
    scrollCardsUpOnList(currentCardIndex: number) {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null || currentCardIndex === 0) return;
      const card: HTMLElement | null = document.querySelector(
        `#views-list .card-view:nth-child(${currentCardIndex + 1})`,
      );
      if (card === null) return;
      const offsetTop = card.offsetTop;
      list.scrollTop = offsetTop - CARD_MARGIN;
    },
    moveCardViewUp() {
      this.moveCardUpOnTouch = true;
      this.cardViewDirection = "up";
      this.isGMapInAction_duplicate = false;
      EventBus.$emit("change-gMap-in-action", false);
    },
    getVacancyObjectByPlaceIdHash(idHash: string): PortalAdapterApi.ResponseGetMergedDisplayVacancy {
      return this.$store.getters["data/getVacancyObjectByPlaceIdHash"](idHash);
    },
    /** @remarks handle touch events on card views */
    handleTouchStart(e: Event) {
      const env = e as TouchEvent;
      this.touchedX = env.changedTouches[0].pageX;
      this.touchedY = env.changedTouches[0].pageY;

      EventBus.$emit("search-again", false);
      EventBus.$emit("toggle-pin-selected-status", "byCardView");
    },
    handleTouchEnd(e: Event) {
      const env = e as TouchEvent;
      const posY = env.changedTouches[0].pageY;
      const posX = env.changedTouches[0].pageX;

      if (Math.abs(posY - this.touchedY) > 50 && Math.abs(posX - this.touchedX) < 50) {
        EventBus.$emit("change-gMap-in-action", false);
        this.cardViewDirection = posY - this.touchedY > 0 ? "down" : "up";
      }
    },
    moveCardMarkerToIndexThenEnlarge(newIndex: number) {
      this.moveCardToIndex(newIndex);
      this.moveMapMarkerTo(newIndex);
      const place: portal.PublicPlaceWithVacancyId | undefined = this.$store.state.data.sortedPlaceList[newIndex];
      if (place === undefined) return;
      sendCardImpression(place, `/${place.placeIdHash}`, this.$gtag);
    },
    moveMapMarkerTo(index: number) {
      // TODO: sprint 11/17
      // it will be merged and refactor here
      // because the UI will be changed again
      const place = this.$store.state.data.sortedPlaceList[index];
      if (place === undefined) return;
      const targetPlaceIdHash: string = place.placeIdHash;
      this.$store.commit("data/setSelectedPlaceIdHash", targetPlaceIdHash);
      EventBus.$emit("move-maps-selected-marker");
      EventBus.$emit("enlarge-selected-marker2");
    },
    moveCardToIndex(index: number) {
      this.hooperRef?.slideTo(index);
      // record same building state
      EventBus.$emit("check-if-place-has-same-building", index);
    },
    addPagerOfPlaceListOnCards() {
      setTimeout(() => {
        if (this.currentCardIndex >= this.numberOfPlaceListOnCards) {
          this.pagerOfPlaceListOnCards =
            this.currentCardIndex % this.amountOfPlaceListOnCards === 0
              ? Math.ceil(this.currentCardIndex / this.amountOfPlaceListOnCards) + 1
              : Math.ceil(this.currentCardIndex / this.amountOfPlaceListOnCards);
        }
      }, 1000);
    },
    /** @remarks listen for scrolling list automaticaly */
    handleListScroll(e: any) {
      if (e.target === null) return;
      const scrolledY = e.target.scrollTop;

      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;

      this.iconTextOn = false;
      const listClientHeight: number = list.clientHeight;
      const listScrollHeight: number = list.scrollHeight;

      if (Math.abs(scrolledY + listClientHeight - listScrollHeight) < 50) {
        this.currentCardIndex = this.numberOfPlaceListOnCards;
      } else {
        const place: portal.PublicPlaceWithVacancyId = this.placeList[this.currentCardIndex];
        const height = place?.building !== undefined ? CARD_HEIGHT_WITH_HEAD : CARD_HEIGHT;
        this.currentCardIndex = Math.round(scrolledY / height);
      }

      // detect scroll direction
      if (scrolledY >= this.scrollLastY) {
        // up
        this.hideMapHeader = true;
      } else {
        this.hideMapHeader = false;
      }
      if (scrolledY <= 0) {
        this.hideMapHeader = false;
      }
      this.scrollLastY = scrolledY;
    },
    listenListSroll() {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;
      (<any>list).addEventListener("scroll", this.handleListScroll, {
        passive: true,
      });
    },
    removeListSroll() {
      const list: HTMLElement | null = document.querySelector("#views-list");
      if (list === null) return;
      (<any>list).removeEventListener("scroll", this.handleListScroll, {
        passive: true,
      });
    },
    /** @remarks listen for move up/down cards */
    listenSwipeGesture() {
      const cardViewSection: HTMLElement | null = document.querySelector("#card-view-section");
      if (cardViewSection === null) return;
      (<any>cardViewSection).addEventListener("touchstart", this.handleTouchStart, { passive: true });
      (<any>cardViewSection).addEventListener("touchend", this.handleTouchEnd, {
        passive: true,
      });
    },
    removeSwipeGesture() {
      const cardViewSection: HTMLElement | null = document.querySelector("#card-view-section");
      if (cardViewSection === null) return;
      (<any>cardViewSection).removeEventListener("touchstart", this.handleTouchStart, { passive: true });
      (<any>cardViewSection).removeEventListener("touchend", this.handleTouchEnd, { passive: true });
    },
    setSectionOffsetTop(timeOutVal: number = 400) {
      const cardViewSection: HTMLElement | null = document.querySelector(`#card-view-section`);

      if (cardViewSection === null) return;

      if (this.showLoadingCard) {
        setTimeout(() => {
          this.setSectionOffsetTop();
        }, 400);
        return;
      }

      setTimeout(() => {
        this.setBottomSectionOffsetTop(cardViewSection.offsetTop);
      }, timeOutVal);
    },
  },
});
